export default __webpack_public_path__ + "d71c88955d3dec4c5dbae81dd90462fe.png";